document.addEventListener("DOMContentLoaded", () => {
  document.querySelectorAll(".large-media").forEach(initializeLargeMediaBlock);
});

document.addEventListener("blockEditorInit", (event) => {
  const block = event.detail.block;

  if (!block) {
    return;
  }

  if (block.matches && block.matches(".large-media")) {
    initializeLargeMediaBlock(block);
  }

  block.querySelectorAll(".large-media").forEach(initializeLargeMediaBlock);
});

function initializeLargeMediaBlock(blockElement) {
  blockElement
    .querySelectorAll("[data-large-media-youtube-trigger]")
    .forEach(initializeLargeMediaYoutubeTrigger);

  blockElement
    .querySelectorAll("[data-large-media-self-hosted-trigger]")
    .forEach(initializeLargeMediaSelfHostedTrigger);

  blockElement
    .querySelectorAll("[data-large-media-autoplay-shell]")
    .forEach(initializeLargeMediaAutoplayShell);
}

function initializeLargeMediaAutoplayShell(shell) {
  if (shell.dataset.largeMediaAutoplayShellInitialized === "true") {
    return;
  }

  shell.dataset.largeMediaAutoplayShellInitialized = "true";

  const startPlayback = () => {
    if (shell.dataset.largeMediaAutoplayStarted === "true") {
      return;
    }

    shell.dataset.largeMediaAutoplayStarted = "true";
    shell.classList.add("is-playing");

    const frame = shell.querySelector("[data-large-media-autoplay-frame]");
    const video = shell.querySelector("[data-large-media-autoplay-video]");

    if (frame) {
      initializeLargeMediaAutoplayFrame(frame);
      if (frame.dataset.videoSrc && !frame.src) {
        frame.src = frame.dataset.videoSrc;
      }
      return;
    }

    if (video) {
      video
        .play()
        .then(() => {
          shell.classList.add("is-loaded");
        })
        .catch(() => {
          shell.classList.add("is-loaded");
        });
    }
  };

  if (!("IntersectionObserver" in window)) {
    startPlayback();
    return;
  }

  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) {
          return;
        }

        startPlayback();
        observer.unobserve(entry.target);
      });
    },
    {
      threshold: 0.35,
      rootMargin: "0px 0px -10% 0px",
    },
  );

  observer.observe(shell);
}

function initializeLargeMediaAutoplayFrame(frame) {
  if (frame.dataset.largeMediaAutoplayFrameInitialized === "true") {
    return;
  }

  frame.dataset.largeMediaAutoplayFrameInitialized = "true";

  frame.addEventListener("load", () => {
    const shell = frame.closest(".large-media__shell--autoplay");

    if (shell) {
      shell.classList.add("is-loaded");
    }
  });

  window.setTimeout(() => {
    const shell = frame.closest(".large-media__shell--autoplay");

    if (shell && shell.dataset.largeMediaAutoplayStarted === "true") {
      shell.classList.add("is-loaded");
    }
  }, 1500);
}

function initializeLargeMediaYoutubeTrigger(trigger) {
  if (trigger.dataset.largeMediaYoutubeTriggerInitialized === "true") {
    return;
  }

  trigger.dataset.largeMediaYoutubeTriggerInitialized = "true";

  trigger.addEventListener("click", () => {
    const frameWrap = trigger.querySelector("[data-large-media-video-frame]");
    const src = trigger.dataset.videoSrc;

    if (!frameWrap || !src) {
      return;
    }

    const iframe = document.createElement("iframe");
    iframe.className = "large-media__video-frame";
    iframe.src = src;
    iframe.title = "Video";
    iframe.allow =
      "accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture";
    iframe.allowFullscreen = true;
    iframe.referrerPolicy = "strict-origin-when-cross-origin";

    frameWrap.innerHTML = "";
    frameWrap.appendChild(iframe);
    frameWrap.setAttribute("aria-hidden", "false");
    trigger.classList.add("is-playing");
  });
}

function initializeLargeMediaSelfHostedTrigger(trigger) {
  if (trigger.dataset.largeMediaSelfHostedTriggerInitialized === "true") {
    return;
  }

  trigger.dataset.largeMediaSelfHostedTriggerInitialized = "true";

  trigger.addEventListener("click", () => {
    const frameWrap = trigger.querySelector("[data-large-media-video-frame]");
    const src = trigger.dataset.videoSrc;

    if (!frameWrap || !src) {
      return;
    }

    const video = document.createElement("video");
    video.className = "large-media__video";
    video.src = src;
    video.controls = true;
    video.autoplay = true;
    video.playsInline = true;

    if (trigger.dataset.videoPoster) {
      video.poster = trigger.dataset.videoPoster;
    }

    frameWrap.innerHTML = "";
    frameWrap.appendChild(video);
    frameWrap.setAttribute("aria-hidden", "false");
    trigger.classList.add("is-playing");
  });
}
